import init from './init';
import state from './state';

const exports = {
  ...init,
  ...state,
};

export default exports;
